import React from "react";

export const OMODA_COMPANY_CHANNELS = [
  { value: "B0", label: "B0 · Base" },
  { value: "B1", label: "B1 · Base +1" },
  { value: "B2", label: "B2 · Base +2" },
  { value: "B3", label: "B3 · Base +3" },
  { value: "B4", label: "B4 · Base +4" },
  { value: "WL", label: "WL · Marque blanche / O&J Lease" },
  { value: "FS", label: "FS · LLD hors O&J Lease" },
  { value: "SD", label: "SD · Tripartites / Special deals" },
];
const percent = (rate) => Number(rate * 100).toLocaleString("fr-FR");

const ARCHIVED_CHANNEL_LABELS = {
  OJ_LEASE_AYVENS: "O&J Lease · Ayvens",
  LLD_HORS_AYVENS: "LLD hors Ayvens",
  VENTES_DIRECTES_AYVENS: "Ventes directes · Ayvens",
  VENTES_DIRECTES_AUTRES: "Ventes directes · autres",
};

export const getOmodaCompanyChannels = (model) => {
  if (!model) return OMODA_COMPANY_CHANNELS;
  return Object.keys(model.company_rates || {}).map((value) => ({
    value,
    label: OMODA_COMPANY_CHANNELS.find((channel) => channel.value === value)?.label || ARCHIVED_CHANNEL_LABELS[value] || value,
  }));
};

export const OmodaCompanyRule = ({ model, category }) => {
  const rate = model.company_rates?.[category];
  if (rate === undefined) return null;
  return <p data-testid="omoda-company-rule" className="mt-4 border-t pt-4 text-sm text-muted-foreground">
    {model.omoda_company_aid_additive ? <>
      Marge de base {percent(model.base_margin_rate)} % + aide société {percent(rate)} % = <strong data-testid="omoda-company-total-rate">{percent(model.base_margin_rate + rate)} % au total</strong>.
    </> : <>Marge société totale : {percent(rate)} %, base incluse.</>}
  </p>;
};